@if (formRevision) {
    <entity-comments
        [(hasComments)]="formRevision.hasComments"
        buttonClass="has-icon mb-0"
        [modalData]="getCommentModalData()">
    </entity-comments>
}
